import { createRouter, createWebHistory } from 'vue-router'
// 引入组件
import HomeView from '../views/Home/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import CultureView from '../views/About/CultureView.vue'
import InstitutionView from '../views/About/InstitutionView.vue'
import HonorsView from '../views/About/HonorsView.vue'
import ProductsView from '../views/ProductsView.vue'
import ContactView from '../views/ContactView.vue'
import ServiceView from '../views/ServiceView.vue'
import NewsView from '../views/NewsView.vue'
import CompanyNews from '../views/CompanyNews.vue'
import DownloadFiles from '../views/DownloadFiles.vue'
import JoinView from '../views/JoinView.vue'
import DetailView from '../views/DetailView.vue'
import ProductsDetail from '../views/ProductsDetail.vue'
import SearchPage from '../views/SearchPage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/products/detail',
    name: 'ProductsDetail',
    component: ProductsDetail
  },
  {
    path: '/institution',
    name: 'institution',
    component: InstitutionView
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: DownloadFiles
  },
  {
    path: '/companynews',
    name: 'companynews',
    component: CompanyNews
  },
  // {
  //   path: '/companynews/:id',
  //   name: 'companynews',
  //   component: CompanyNews
  // },
  {
    path: '/companynews/detail',
    name: 'companyNewsDetail',
    component: DetailView
  },
  {
    path: '/companynews/search',
    name: 'companyNewsSearch',
    component: SearchPage
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/news/details',
    name: 'NewsDetails',
    component: DetailView
  },
  {
    path: '/culture',
    name: 'culture',
    component: CultureView
  },
  {
    path: '/honors',
    name: 'honors',
    component: HonorsView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/service',
    name: 'service',
    component: ServiceView
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: JoinView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router     